"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredicateRelatedFieldEvaluationHandler = void 0;
const pex_models_1 = require("@sphereon/pex-models");
const ConstraintUtils_1 = require("../../ConstraintUtils");
const Messages_1 = __importDefault(require("../../types/Messages"));
const abstractEvaluationHandler_1 = require("./abstractEvaluationHandler");
class PredicateRelatedFieldEvaluationHandler extends abstractEvaluationHandler_1.AbstractEvaluationHandler {
    constructor(client) {
        super(client);
    }
    getName() {
        return 'PredicateRelatedFieldEvaluation';
    }
    handle(pd) {
        // PresentationDefinitionV2 is the common denominator
        pd.input_descriptors.forEach((inDesc, index) => {
            if (inDesc.constraints) {
                this.examinePredicateRelatedField(index, inDesc.constraints);
            }
        });
        // this.updatePresentationSubmission(pdV1);
    }
    examinePredicateRelatedField(input_descriptor_idx, constraints) {
        if (constraints === null || constraints === void 0 ? void 0 : constraints.fields) {
            for (let i = 0; i < constraints.fields.length; i++) {
                for (let j = 0; j < this.getResults().length; j++) {
                    this.examinePredicateForFilterEvaluationResult(this.getResults(), j, input_descriptor_idx, constraints, i);
                }
            }
        }
    }
    examinePredicateForFilterEvaluationResult(results, resultIdx, input_descriptor_idx, constraints, fieldIdx) {
        var _a;
        const resultInputDescriptorIdx = this.retrieveResultInputDescriptorIdx(results[resultIdx].input_descriptor_path);
        if (results[resultIdx].payload &&
            results[resultIdx].payload.result &&
            results[resultIdx].payload.result.path &&
            results[resultIdx].evaluator === 'FilterEvaluation' &&
            input_descriptor_idx === resultInputDescriptorIdx &&
            constraints &&
            constraints.fields &&
            constraints.fields[fieldIdx] &&
            constraints.fields[fieldIdx].predicate &&
            constraints.fields[fieldIdx].path &&
            ((_a = constraints.fields[fieldIdx].path) === null || _a === void 0 ? void 0 : _a.includes(this.concatenatePath(results[resultIdx].payload.result.path)))) {
            const evaluationResult = Object.assign({}, results[resultIdx].payload.result);
            const resultObject = this.createResultObject(input_descriptor_idx, resultIdx, evaluationResult, results);
            if (constraints.fields[fieldIdx].predicate === pex_models_1.Optionality.Required) {
                results.push(resultObject);
            }
            else {
                resultObject.payload['value'] = true;
                results.push(resultObject);
            }
        }
    }
    retrieveResultInputDescriptorIdx(input_descriptor_path) {
        const inputDescriptorText = '$.input_descriptors[';
        const startIdx = input_descriptor_path.indexOf(inputDescriptorText);
        const startWithIdx = input_descriptor_path.substring(startIdx + inputDescriptorText.length);
        const endIdx = startWithIdx.indexOf(']');
        const idx = startWithIdx.substring(0, endIdx);
        return parseInt(idx);
    }
    concatenatePath(path) {
        let completePath = '';
        for (let i = 0; i < path.length; i++) {
            if (typeof path[i] === 'number') {
                completePath = completePath.substring(0, completePath.length - 1);
                completePath += '[*].';
            }
            else {
                completePath += path[i] + '.';
            }
        }
        return completePath.substring(0, completePath.length - 1);
    }
    createResultObject(input_descriptor_idx, resultIdx, evaluationResult, results) {
        return {
            input_descriptor_path: `$.input_descriptors[${input_descriptor_idx}]`,
            verifiable_credential_path: results[resultIdx].verifiable_credential_path,
            evaluator: this.getName(),
            status: ConstraintUtils_1.Status.INFO,
            message: Messages_1.default.INPUT_CANDIDATE_IS_ELIGIBLE_FOR_PRESENTATION_SUBMISSION,
            payload: evaluationResult,
        };
    }
}
exports.PredicateRelatedFieldEvaluationHandler = PredicateRelatedFieldEvaluationHandler;
